import { useCallback, useEffect } from "react";
import { toast } from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import AccountForm from "../../components/forms/admin-edit-clerk-form";
import Header from "../../components/header";
import { AdminEditClerkFormValues, useAdminEditClerkForm } from '../../forms/account/admin-edit-clerk-form';
import { Account } from "../../models/account";
import { AccountService } from "../../services/account-service";
import { ClerksService } from '../../services/clerks-service';

export default function EditClerk() {
  const navigate = useNavigate();
  const { clerkId } = useParams<{ clerkId: string }>();
  const editAccountForm = useAdminEditClerkForm();

  const initForm = useCallback(
    (clerk?: Account) => {
      editAccountForm.reset({
        firstName: clerk?.firstName,
        lastName: clerk?.lastName,
        email: clerk?.email,
        phone: clerk?.phone,
        county: clerk?.county,
        municipality: clerk?.municipality,
        streetAddress: clerk?.address1,
        aptSuiteBuilding: clerk?.address2,
        city: clerk?.city,
        state: clerk?.state.id,
        zipCode: clerk?.postalCode,
      });
    },
    [editAccountForm]
  );

  const onEditClerk = async (values: AdminEditClerkFormValues) => {
    await toast.promise(
      ClerksService.updateClerk({
        id: clerkId!,
        firstName: values.firstName,
        lastName: values.lastName,
        phone: values.phone,
        email: values.email,
        county: values.county,
        municipality: values.municipality,
        address1: values.streetAddress,
        address2: values.aptSuiteBuilding,
        city: values.city,
        stateId: values.state,
        postalCode: values.zipCode,
      }),
      {
        loading: "Saving...",
        success: (data) => {
          initForm(data as Account);
          navigate(-1);
          return <b>Successful clerk edit!</b>;
        },
        error: (e) => {
          return e?.response?.data
            ? e.response.data
            : e.message ?? "An Error Occurred.";
        },
      },
      { duration: 5000 }
    );
  };

  useEffect(() => {
    (async () => {
      if (clerkId) {
        try {
          const clerk = await AccountService.getClerk(clerkId);
          initForm(clerk);
        } catch (e) {
          toast.error("No clerk found");
          navigate("/clerks");
        }
      }
    })();
  }, [clerkId, editAccountForm, navigate, initForm]);

  return (
    <>
      <Header>
        <div className="container w-full mx-auto">
          <div className="container h-[80px] mx-auto text-3xl text-white font-semibold flex items-center">
            Edit Clerk
          </div>
        </div>
      </Header>
      <AccountForm onSubmit={onEditClerk} form={editAccountForm} mode="edit" />
    </>
  );
}
